import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { SectorsMarquee } from '../components/home/SectorsMarquee';
import { IntroSection } from '../components/home/IntroSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { ImpactSection } from '../components/home/ImpactSection';
import { ProcessSection } from '../components/home/ProcessSection';
import { CaseStudiesSection } from '../components/home/CaseStudiesSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { FaqSection } from '../components/FaqSection';
import { BlogPreview } from '../components/home/BlogPreview';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <>
      <HeroSection data-id="element-634" data-mp="2dfdunz15t2vv" />
      <SectorsMarquee data-id="element-635" data-mp="3kvtlxfztbtyh" />
      <IntroSection data-id="element-636" data-mp="3ku8sxut5cj2q" />
      <ServicesSection data-id="element-637" data-mp="3kuqzbk9iwdod" />
      <ProcessSection data-id="element-638" data-mp="3kxms6u6ikc5y" />
      <ImpactSection data-id="element-639" data-mp="3owcghht3be4d" />
      <CaseStudiesSection data-id="element-640" data-mp="3ovucu043lxmf" />
      <TestimonialsSection data-id="element-641" data-mp="3ov2fokuurru1" />
      <BlogPreview data-id="element-642" data-mp="30wroqfcbfvf0" />
      <FaqSection data-id="element-643" data-mp="30xb71x5voltk" />
      <CtaBanner data-id="element-644" data-mp="30vqeue71deyv" />
    </>;
}